import React, { useCallback, useMemo } from "react";
import { Icon, IconButton, Tooltip } from "@material-ui/core";
import useSurveys from "../state/hooks/useSurveys";
import { isEmpty, isNil } from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  jumpingIcon: {
    animation: "$jumpEffect 3s infinite ease-in-out",
    color: "goldenrod",
  },
  "@keyframes jumpEffect": {
    "0%": { transform: "translateY(0)" },
    "25%": { transform: "rotate(90deg)", scale: "1.1" },
    "50%": { transform: "translateY(-5px)", scale: "1.1" },
    "75%": { transform: "rotate(1800deg)", scale: "1.1" },
    "100%": { transform: "translateY(0)" },
  },
});

export default function SurveyButton() {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    skipPressed,
    loadingSurverys,
    surveys,
    showSurveysDialog,
    openSurveyDialog,
    closedSurveyInMiddle,
  } = useSurveys();

  const closedState = useMemo(() => {
    return (
      skipPressed === true ||
      (showSurveysDialog === false && !isNil(surveys) && !isEmpty(surveys)) ||
      closedSurveyInMiddle === true
    );
  }, [showSurveysDialog, skipPressed, surveys, closedSurveyInMiddle]);

  const handleOpen = useCallback(() => {
    openSurveyDialog();
  }, [openSurveyDialog]);

  if (loadingSurverys || !closedState) {
    return null;
  }

  return (
    <Tooltip title={t("SURVEYS_BTN_PENDING")}>
      <IconButton onClick={handleOpen}>
        <Icon className={`fas fa-star-half-alt ${classes.jumpingIcon}`} />
      </IconButton>
    </Tooltip>
  );
}
